import React from "react";
import { listingStates } from "../../../../util/flStates";
import DashListings from "../DashListings/DashListings";

function DashSellListings({
  passedListings = [],
  accessToken,
  role,
  handleRestore,
}) {
  return (
    <DashListings
      passedListings={passedListings}
      accessToken={accessToken}
      listingType={listingStates.sell}
      handleRestore={handleRestore}
      role={role}
    />
  );
}

export default DashSellListings;
